import { io } from 'socket.io-client';

class SocketService {
    constructor() {
        const baseUrl =
            process.env.NODE_ENV === 'development'
                ? `${process.env.REACT_APP_API_URL}:${process.env.REACT_APP_API_PORT}`
                : process.env.REACT_APP_API_URL;
        this.socket = io(baseUrl, {
            transports: ['websocket'],
            withCredentials: true,
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000,
        });

        this.listeners = new Map();

        this.socket.on('connect', () => {
            
        });

        this.socket.on('connect_error', (err) => {
            
        });

        this.socket.on('disconnect', () => {
            
        });
    }

    isConnected() {
        return this.socket.connected;
    }

    on(event, callback) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, callback);
            this.socket.on(event, callback);
        }
    }

    off(event) {
        const callback = this.listeners.get(event);
        if (callback) {
            this.socket.off(event, callback);
            this.listeners.delete(event);
        }
    }

    emit(event, data) {
        this.socket.emit(event, data);
    }
}

export default new SocketService();
